var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v31.282c0 147.017-244.348 147.422-244.348-3.672V0",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(374.817 363.26)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c15.226 26.166 30.736 41.778 63.358 43.542 20.225 1.069 33.107 5.493 46.961 21.654 1.715 1.995 5.285 5.638 7.827 8.24M46.59-137.967h-8.798c-57.331 0-103.949 12.201-79.211 59.501l27.308 52.185",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(80.709 171.632)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.514-.896 1.343-1.821 1.942-2.718C35.364-53.978 150.396-49.41 178.705.173",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(166.433 218.96)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c36.963 9.136 61.016 8.876 81.754-3.064",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(390.957 96.23)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-36.992 9.136-61.044 8.876-81.782-3.064",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(121.071 96.23)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.827c57.301 0 103.92 12.201 79.183 59.5l-32.765 62.624c-18.624 35.647-33.278 57.302-72.013 59.384-20.224 1.099-33.079 5.464-46.961 21.655-2.743 3.209-10.398 10.784-10.798 11.362",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(384.701 33.665)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v16.335c-.771 136.001-195.673 117.815-195.673 6.303V0h12.226c9.541 0 15.111 4.134 22.11 14.34 15.739 22.956 19.91 14.514 38.163 3.325C-109.891 9.57-94.009 0-55.988 0Z",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(350.48 366.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-13.797c-11.397.029-20.71-9.425-20.71-20.961V-34.81c0-11.506 9.313-20.961 20.71-20.961H1.428",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(154.807 366.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.797.029c11.397 0 20.71-9.454 20.71-20.961v-13.849c0-11.535-9.313-20.961-20.71-20.961H-1.429",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(350.48 366.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-42.327c0-35.764 33.05-80.664 73.441-95.842 17.768-6.679 31.137-6.65 48.904.029 40.335 15.236 73.328 60.078 73.328 95.813V0",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(154.807 366.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.797 0 24.995-9.83 24.995-21.916 0-12.113-11.198-21.915-24.995-21.915-13.826 0-24.995 9.802-24.995 21.915C-24.995-9.83-13.826 0 0 0Z",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256.014 103.516)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v9.338",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(219.593 315.786)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v9.338",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(284.95 315.786)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h106.749c6.627 0 12.683-5.522 12.025-12.172l-12.368-123.887c-.657-6.649-5.399-12.143-12.026-12.143h-230.551c-6.599 0-11.369 5.494-12.026 12.143l-12.369 123.887C-161.223-5.522-155.167 0-148.54 0h110.405",
    style: {
      strokeWidth: 15.118,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(276.896 155.702)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15.118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#fff",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.4cf078bfe4dbc497363a004b41c50a00.svg";
export { ForwardRef as ReactComponent };